import React, { useState, useEffect } from "react";
import { 
    Card, Row, Col, Form, Button, Alert, Spinner 
} from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import Footer from "../layouts/Footer";
import Header from "../layouts/Header";
import './Produits.css';

export default function AjouterProduit() {
    const navigate = useNavigate();
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    
    const [produit, setProduit] = useState({
        reference: '',
        code_barre: '',
        designation: '',
        description: '',
        id_categorie: '',
        unite_mesure: 'PCE',
        prix_achat_ht: 0,
        prix_vente_ht: 0,
        tva_taux: 18,
        css_taux: 1,
        seuil_alerte: 5,
        stock_minimum: 0,
        stock_maximum: '',
        emplacement: '',
        actif: 1
    });

    useEffect(() => {
        fetchCategories();
    }, []);

    const fetchCategories = async () => {
        try {
            const token = localStorage.getItem("token");
            const response = await fetch(
                'https://sawd.julesferry-ga.com/api/categories.php',
                { headers: { 'Authorization': `Bearer ${token}` } }
            );
            
            if (response.ok) {
                const result = await response.json();
                setCategories(result.data || []);
            }
        } catch (err) {
            console.error("Erreur chargement catégories", err);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!produit.designation) {
            setError("La désignation est obligatoire");
            return;
        }
        
        if (!produit.prix_achat_ht || produit.prix_achat_ht <= 0) {
            setError("Le prix d'achat doit être supérieur à 0");
            return;
        }
        
        if (!produit.prix_vente_ht || produit.prix_vente_ht <= 0) {
            setError("Le prix de vente doit être supérieur à 0");
            return;
        }

        setSaving(true);
        setError("");

        try {
            const token = localStorage.getItem("token");
            const response = await fetch(
                'https://sawd.julesferry-ga.com/api/produits.php',
                {
                    method: 'POST',
                    headers: { 
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(produit)
                }
            );

            const result = await response.json();

            if (result.success) {
                setSuccess("Produit créé avec succès !");
                setTimeout(() => {
                    navigate('/stock/produits');
                }, 2000);
            } else {
                setError(result.message || "Erreur lors de la création");
            }
        } catch (err) {
            setError("Erreur de connexion au serveur");
        } finally {
            setSaving(false);
        }
    };

    return (
        <React.Fragment>
            <Header />
            <div className="main main-app p-3 p-lg-4">
                <div className="container-fluid">
                    {/* En-tête */}
                    <Row className="mb-4">
                        <Col md={12}>
                            <div className="d-flex justify-content-between align-items-center">
                                <div>
                                    <ol className="breadcrumb fs-sm mb-1">
                                        <li className="breadcrumb-item"><Link to="/dashboard">Tableau de bord</Link></li>
                                        <li className="breadcrumb-item"><Link to="/stock">Stock</Link></li>
                                        <li className="breadcrumb-item"><Link to="/stock/produits">Produits</Link></li>
                                        <li className="breadcrumb-item active">Nouveau produit</li>
                                    </ol>
                                    <h4 className="main-title mb-0">
                                        <i className="ri-add-line text-primary me-2"></i>
                                        Ajouter un produit
                                    </h4>
                                </div>
                            </div>
                        </Col>
                    </Row>

                    {error && (
                        <Alert variant="danger" onClose={() => setError("")} dismissible>
                            <i className="ri-error-warning-line me-2"></i>
                            {error}
                        </Alert>
                    )}
                    
                    {success && (
                        <Alert variant="success">
                            <i className="ri-checkbox-circle-line me-2"></i>
                            {success}
                        </Alert>
                    )}

                    <Row className="justify-content-center">
                        <Col lg={8}>
                            <Card className="border-0 shadow-sm">
                                <Card.Header className="bg-primary text-white">
                                    <h5 className="mb-0">
                                        <i className="ri-information-line me-2"></i>
                                        Informations du produit
                                    </h5>
                                </Card.Header>
                                <Card.Body>
                                    <Form onSubmit={handleSubmit}>
                                        <Row className="g-3">
                                            <Col md={6}>
                                                <Form.Group>
                                                    <Form.Label>Référence</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        value={produit.reference}
                                                        onChange={(e) => setProduit({...produit, reference: e.target.value})}
                                                        placeholder="Générée automatiquement si vide"
                                                    />
                                                    <Form.Text className="text-muted">
                                                        Laissez vide pour génération automatique
                                                    </Form.Text>
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group>
                                                    <Form.Label>Code-barres</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        value={produit.code_barre}
                                                        onChange={(e) => setProduit({...produit, code_barre: e.target.value})}
                                                        placeholder="Optionnel"
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={12}>
                                                <Form.Group>
                                                    <Form.Label>Désignation <span className="text-danger">*</span></Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        value={produit.designation}
                                                        onChange={(e) => setProduit({...produit, designation: e.target.value})}
                                                        required
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={12}>
                                                <Form.Group>
                                                    <Form.Label>Description</Form.Label>
                                                    <Form.Control
                                                        as="textarea"
                                                        rows={3}
                                                        value={produit.description}
                                                        onChange={(e) => setProduit({...produit, description: e.target.value})}
                                                        placeholder="Description du produit..."
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group>
                                                    <Form.Label>Catégorie</Form.Label>
                                                    <Form.Select
                                                        value={produit.id_categorie}
                                                        onChange={(e) => setProduit({...produit, id_categorie: e.target.value})}
                                                    >
                                                        <option value="">Sélectionner une catégorie</option>
                                                        {categories.map(cat => (
                                                            <option key={cat.id_categorie} value={cat.id_categorie}>
                                                                {cat.nom_categorie}
                                                            </option>
                                                        ))}
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group>
                                                    <Form.Label>Unité de mesure</Form.Label>
                                                    <Form.Select
                                                        value={produit.unite_mesure}
                                                        onChange={(e) => setProduit({...produit, unite_mesure: e.target.value})}
                                                    >
                                                        <option value="PCE">Pièce</option>
                                                        <option value="KG">Kilogramme</option>
                                                        <option value="L">Litre</option>
                                                        <option value="M">Mètre</option>
                                                        <option value="CART">Carton</option>
                                                        <option value="PAL">Palette</option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group>
                                                    <Form.Label>Prix d'achat HT <span className="text-danger">*</span></Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        step="0.01"
                                                        min="0"
                                                        value={produit.prix_achat_ht}
                                                        onChange={(e) => setProduit({...produit, prix_achat_ht: parseFloat(e.target.value) || 0})}
                                                        required
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group>
                                                    <Form.Label>Prix de vente HT <span className="text-danger">*</span></Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        step="0.01"
                                                        min="0"
                                                        value={produit.prix_vente_ht}
                                                        onChange={(e) => setProduit({...produit, prix_vente_ht: parseFloat(e.target.value) || 0})}
                                                        required
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={4}>
                                                <Form.Group>
                                                    <Form.Label>TVA (%)</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        step="0.1"
                                                        min="0"
                                                        max="100"
                                                        value={produit.tva_taux}
                                                        onChange={(e) => setProduit({...produit, tva_taux: parseFloat(e.target.value) || 0})}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={4}>
                                                <Form.Group>
                                                    <Form.Label>CSS (%)</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        step="0.1"
                                                        min="0"
                                                        max="100"
                                                        value={produit.css_taux}
                                                        onChange={(e) => setProduit({...produit, css_taux: parseFloat(e.target.value) || 0})}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={4}>
                                                <Form.Group>
                                                    <Form.Label>Seuil d'alerte</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        min="0"
                                                        value={produit.seuil_alerte}
                                                        onChange={(e) => setProduit({...produit, seuil_alerte: parseInt(e.target.value) || 0})}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={4}>
                                                <Form.Group>
                                                    <Form.Label>Stock minimum</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        min="0"
                                                        value={produit.stock_minimum}
                                                        onChange={(e) => setProduit({...produit, stock_minimum: parseInt(e.target.value) || 0})}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={4}>
                                                <Form.Group>
                                                    <Form.Label>Stock maximum</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        min="0"
                                                        value={produit.stock_maximum}
                                                        onChange={(e) => setProduit({...produit, stock_maximum: parseInt(e.target.value) || ''})}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={4}>
                                                <Form.Group>
                                                    <Form.Label>Emplacement</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        value={produit.emplacement}
                                                        onChange={(e) => setProduit({...produit, emplacement: e.target.value})}
                                                        placeholder="Ex: A-12-3"
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={12}>
                                                <hr />
                                                <div className="d-flex gap-3">
                                                    <Button 
                                                        variant="outline-secondary" 
                                                        onClick={() => navigate('/stock/produits')}
                                                    >
                                                        Annuler
                                                    </Button>
                                                    <Button 
                                                        type="submit" 
                                                        variant="primary"
                                                        disabled={saving}
                                                    >
                                                        {saving ? (
                                                            <>
                                                                <Spinner size="sm" className="me-2" />
                                                                Création...
                                                            </>
                                                        ) : (
                                                            <>
                                                                <i className="ri-save-line me-2"></i>
                                                                Créer le produit
                                                            </>
                                                        )}
                                                    </Button>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Form>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </div>
                <Footer />
            </div>
        </React.Fragment>
    );
}